const ROLES = {
    SUPER_ADMINISTRATOR: 1,
    ADMINISTRATOR: 2,
    CLIENT_SUCCESS: 3,
    TEAM_USER: 4,
    COMPLIANCE_OFFICER: 5,
    AGENT: 6,
    BRAND_USER: 7,
};
const PERMISSIONS = {
    TEAM_ADMIN: 2,
    TEAM_CONTENT_HUB_READ: 3,
    TEAM_CONTENT_HUB_WRITE: 4,
    TEAM_DASHBOARD_READ: 5,
    TEAM_SOCIAL_CHANNELS_READ: 6,
    TEAM_SOCIAL_CHANNELS_WRITE: 7,
    TEAM_SOCIAL_FEED_READ: 8,
    TEAM_NOTIFICATIONS_READ: 9,
    TEAM_NOTIFICATIONS_WRITE: 10,
    ATHLETE_PROFILE_READ: 11,
    ATHLETE_PROFILE_WRITE: 12,
    TEAM_CONTENT_HUB_MEDIA_TAGGED_ONLY_READ: 13,
    TEAM_MESSAGING_READ: 14,
    TEAM_CAMPAIGN_READ: 15,
    TEAM_CAMPAIGN_WRITE: 16,
    MEDIA_REQUEST_READ: 17,
    MEDIA_REQUEST_WRITE: 18,
    TEAM_PROVIDER_READ: 19,
    OPPORTUNITIES_READ: 20,
    OPPORTUNITIES_WRITE: 21,
    TRANSACTIONS_READ: 22,
    TRANSACTIONS_WRITE: 23,
    FMV_VIEW: 24,
    LEADERBOARD_READ: 25,
    LEADERBOARD_WRITE: 26,
    SERVICE_PROVIDER_READ: 27,
    TRANSACTIONS_IMPORT_WRITE: 28,
};
const AGENT_DISALLOWED_PERMISSIONS = [
    PERMISSIONS.TEAM_ADMIN,
    PERMISSIONS.TEAM_CONTENT_HUB_WRITE,
    PERMISSIONS.TEAM_CAMPAIGN_READ,
    PERMISSIONS.TEAM_CAMPAIGN_WRITE,
    PERMISSIONS.MEDIA_REQUEST_READ,
    PERMISSIONS.MEDIA_REQUEST_WRITE,
    PERMISSIONS.OPPORTUNITIES_WRITE,
    PERMISSIONS.LEADERBOARD_WRITE,
    PERMISSIONS.TRANSACTIONS_IMPORT_WRITE,
];
const APP_SWITCHER_SLUGS = {
    AMS: 'ams',
    ARMS: 'arms',
    ACADEMICS: 'academics',
    CAMPS: 'camps',
    COACHING: 'coaching',
    COLLECTIVES: 'collectives',
    COMMUNITIES: 'communities',
    GM: 'gm',
    HUB: 'hub',
    INFLCR: 'inflcr',
    INVENTORY: 'inventory',
    NUTRITION: 'nutrition',
    PATHWAYS: 'pathways',
    PULSE: 'pulse',
    STRENGTH: 'strength',
    NOTEMEAL: 'notemeal',
    RETAIN: 'retain',
    SCOUTING: 'scouting',
    SMARTABASE: 'smartabase',
    WHISTLE: 'whistle',
};
export { PERMISSIONS, AGENT_DISALLOWED_PERMISSIONS, ROLES, APP_SWITCHER_SLUGS, };
